<template>
  <div class="rew19_aro_wrap shop">
    <div class="rew19_contents_inner">
      <h2 class="rew19_second_title">나의 NTC 상세</h2>

      <h3 class="rew19_third_title">신청자 정보</h3>
      <ul class="rew19_underline_list">
        <li class="type1">
          <em>NTC 주문번호</em>
          <span class="substance">{{viewData.ntcNo}}</span>
        </li>
        <li class="type1">
          <em>신청자</em>
          <span class="substance">{{viewData.member_name}} ({{viewData.member_id}})</span>
        </li>
        <li class="type1">
          <em>전화번호</em>
          <span class="substance">{{viewData.ship_tel}}</span>
        </li>
        <li class="type1">
          <em>핸드폰 번호</em>
          <span class="substance">{{viewData.ship_phone}}</span>
        </li>
        <li class="type1">
          <em>이메일</em>
          <span class="substance">{{viewData.email}}</span>
        </li>
      </ul>

      <h3 class="rew19_third_title">결제 정보</h3>
      <ul class="rew19_underline_list">
        <li class="type1">
          <em>결제일</em>
          <span class="substance">
            <span class="gep_btnRight">매월 {{viewData.payment_date}}일</span>
            <a @click="openChangeNtcPaymentDateDialog" class="rew19_btn_border">변경</a>
          </span>
        </li>
        <li class="type1">
          <em>카드 번호</em>
          <span class="substance">
            <span class="gep_btnRight">{{viewData.print_ccard_no}}</span>
            <a @click="openPaymentInfoDialog" class="rew19_btn_border">변경</a>
          </span>
        </li>
      </ul>

      <h3 class="rew19_third_title">
        기부 내역
        <a @click="openChangeNtcProductDialog" class="rew19_btn_T1 inthird">
          <span>변경</span>
        </a>
      </h3>

      <div v-for="(pd, idx) in viewData.pd_list" v-bind:key="idx" class="rew19_payment_content" v-show="viewData.pd_list && viewData.pd_list.length > 0">
          <div class="rew19_flex_box" v-show="pd.pd_count > 0">
            <div class="rew19_payment_list__img">
              <img :src="pd.pd_img_url1"
                   onError="imageError(this)" data-error-cnt="0"
              />
            </div>

            <div class="rew19_payment_list__infor">
              <h4>{{pd.pd_name_kr}}</h4>
              <ul class="rew19_payment_items">
                <li>
                  <span class="rew19_point rew19_gDetail">{{$fmt.WON(pd.membersPrice)}} 원 / {{pd.pd_count}}개</span>
                </li>
                <li v-if="getMemberType() == 'DIST'">
                  <span class="rew19_gDetail">
                    <em>NTC SV</em> {{$fmt.PV(pd.pv)}}
                  </span>
                </li>
                <li>
                  <span class="rew19_gDetail">
                    <em>합계</em> {{$fmt.WON(pd.pd_amt)}} 원
                  </span>
                </li>
              </ul>
            </div>
          </div>
      </div>

      <div v-show="viewData.pd_list && viewData.pd_list.length <= 0">
        <div v-if="viewData.product1Quantity > 0" class="rew19_payment_content">
          <div class="rew19_flex_box">
            <div class="rew19_payment_list__img">
              <img :src="viewData.p1_pd_img_url1"
                   onError="imageError(this)" data-error-cnt="0"
              />
            </div>

            <div class="rew19_payment_list__infor">
              <h4>바이타밀 1포</h4>
              <ul class="rew19_payment_items">
                <li>
                  <span class="rew19_point rew19_gDetail">{{$fmt.WON(viewData.product1Price)}} 원 / {{viewData.product1Quantity}}개</span>
                </li>
                <li v-if="getMemberType() == 'DIST'">
                  <span class="rew19_gDetail">
                    <em>NTC SV</em> {{$fmt.PV(viewData.product1Pv)}}
                  </span>
                </li>
                <li>
                  <span class="rew19_gDetail">
                    <em>합계</em> {{$fmt.WON(viewData.totalProduct1Price)}} 원
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div v-if="viewData.product5Quantity > 0" class="rew19_payment_content">
          <div class="rew19_flex_box">
            <div class="rew19_payment_list__img">
              <img :src="viewData.p5_pd_img_url1"
                   onError="imageError(this)" data-error-cnt="0"
              />
            </div>

            <div class="rew19_payment_list__infor">
              <h4>바이타밀 5포</h4>
              <ul class="rew19_payment_items">
                <li>
                  <span class="rew19_point rew19_gDetail">{{$fmt.WON(viewData.product5Price)}} 원 / {{viewData.product5Quantity}}개</span>
                </li>
                <li v-if="getMemberType() == 'DIST'">
                  <span class="rew19_gDetail">
                    <em>NTC SV</em> {{$fmt.PV(viewData.product5Pv)}}
                  </span>
                </li>
                <li>
                  <span class="rew19_gDetail">
                    <em>합계</em> {{$fmt.WON(viewData.totalProduct5Price)}} 원
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="rew19_payment_bottom">
        <ul class="rew19_payList">
          <li v-if="getMemberType() == 'DIST'">
            <em class="rew19_payTitle">합계 SV</em>
            <span class="rew19_payDetail">{{$fmt.PV(viewData.totalPv)}}</span>
          </li>
          <li v-bind:class="{lastLine : getMemberType() == 'DIST'}">
            <em class="rew19_payTitle">주문금액</em>
            <span class="rew19_payDetail rew19_point">
              <strong>{{$fmt.WON(viewData.totalPrice)}} 원</strong>
            </span>
          </li>
        </ul>
      </div>

      <div class="rew19_responsive_btns gepTaye1">
        <a href="#" class="rew19-btn-normal" @click.stop.prevent="onClickCancelNtc(viewData.ntcNo)">철회하기</a>
        <router-link :to="{name:'ntcCurrentList'}" class="rew19-btn-border">목록</router-link>
      </div>
    </div>
    <!--rew19_contents_inner-->

    <ntc-product-dialog
      :show="ntcProductDialogShow"
      @close="changeNtcProduct"
      ref="ntcProductDialog"
    ></ntc-product-dialog>

    <payment-date-dialog
      :show="paymentDateDialogShow"
      @close="changePaymentDate"
      ref="paymentDateDialog"
    ></payment-date-dialog>

    <payment-info-dialog
      :show="paymentInfoDialogShow"
      :mode="paymentInfoDialog.mode"
      :showCardTerm="true"
      :showInstMonth="false"
      :showReceiptNo="false"
      @close="changePaymentInfo"
      ref="paymentInfoDialog"
    ></payment-info-dialog>

  </div>
</template>
<script>
import AroBase from '@/components/base/AroBase';
import NtcProductDialog from '@/components/popup/NtcProductDialog';
import PaymentDateDialog from '@/components/popup/PaymentDateDialog';
import PaymentInfoDialog from '@/components/popup/PaymentInfoDialog';
import * as Const from "@/utils/const";
import * as ErrMsg from "@/utils/error_msg";
import * as Crypto from '@/utils/cryptoUtil';

import DF from 'dateformat';

export default {
  name: "ntcCurrentDetail",
  extends: AroBase,
  components: {
    NtcProductDialog,
    PaymentDateDialog,
    PaymentInfoDialog
  },
  computed: {
     isNuskinChannel : function() {
       return this.$aroChannel == Const.ARO_CHANNEL_NUSKIN;
     }
  },
  data() {
    return {
      //View Data
      viewData : {},
      params : {

      },

      // 제품 정보 변경
      ntcProductDialogShow : false,
      ntcProductDialog : {
      },

      // 결제일 변경
      paymentDateDialogShow : false,
      paymentDateDialog : {},

      //결제정보
      paymentInfoDialogShow : false,
      paymentInfoDialog : {},

      testText : ""
    };
  },
  created() {
  },
  mounted() {
    let _this = this;

    _this.loadData();
  },
  methods: {
    /**
     * JQuery UI
     */
    initUI(){

    },

    /**
     * API Request
     */
    //나의 ntc 정보 가져오기
    apiGetNtc(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_ntc`, {});
    },

    //ntc 철회하기
    apiCancelNtc(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/cancel_ntc`, {});
    },

    apiNtcPutProducts(qtyInfo){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/ntc/put_products`, {
        params : {
          newApi : true,
          pd_list : JSON.stringify(qtyInfo)
        }
      });
    },

    // ntc 결제일 변경
    apiNtcPutDeliveryDay(data){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/ntc/put_delivery_day`, {
        params : {
          ...data
        }
      });
    },

    // ntc 결제정보 변경
    apiNtcPutPay(paymentInfo){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/ntc/put_pay`, {
        params : {
          ...paymentInfo
        }
      });

    },

    /**
     * Local function
     */
    //데이터 로드
    loadData(){
      let _this = this;

      //show loading
      _this.$showLoading();
      _this.apiGetNtc().then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.viewData = {...res.data};

        }else{
          //console.error(res);
          _this.$dialogs.alert(res.data.message).then(res => {});
        }

      }).catch(()=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{

        //hide loading
        _this.$hideLoading();
      });
    },

    // 철회하기
    onClickCancelNtc : function(ntc_no){
      let _this = this;

      const options = {cancelLabel: '취소', okLabel:'확인'};
      _this.$dialogs.confirm("NTC " + ntc_no + " 정기기부를 철회하시겠습니까?", options).then(res=>{
        if(res.ok){
          _this.doCancelNtc();
        }
      });
    },

    // 철회하기
    doCancelNtc(){
      let _this = this;

      //show loading
      _this.$showLoading();
      _this.apiCancelNtc().then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.$dialogs.alert("회원님의 정기기부가 철회되었습니다.", {okLabel:"확인"})
          .then(res => {});

          //_this.loadData();
          _this.$router.push(`${_this.$aroBasePath}/ntcCurrentList`);
        }else{
          //console.error(res);
          _this.$dialogs.alert(res.data.message).then(res => {});
        }

      }).catch(()=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    //Open dialog 상품 정보 변경
    openChangeNtcProductDialog(){
      let _this = this;

      _this.ntcProductDialog = {
        ..._this.viewData
      }

      _this.$refs.ntcProductDialog.initData(_this.ntcProductDialog);
      _this.ntcProductDialogShow = true;
    },

     //ntc 상품 정보 변경
    changeNtcProduct(isOk, data){
      let _this = this;
      _this.ntcProductDialogShow = false;

      if(!isOk){
        return;
      }

      _this.$showLoading();
      _this.apiNtcPutProducts(data).then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.$dialogs.alert("NTC 제품 정보 변경되었습니다.", {okLabel:"확인"})
          .then(res => {});

          _this.loadData();

        }else{
          //console.error(res);
          _this.$dialogs.alert(res.data.message).then(res => {});
        }

      }).catch(()=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    //Open dialog 결제일 변경
    openChangeNtcPaymentDateDialog(){
      let _this = this;

      _this.paymentDateDialog = {
        payment_day : _this.viewData.payment_date
      }

      _this.$refs.paymentDateDialog.initData(_this.paymentDateDialog);
      _this.paymentDateDialogShow = true;
    },

     //결제일 변경
    changePaymentDate(isOk, data){
      let _this = this;
      _this.paymentDateDialogShow = false;

      if(!isOk){
        return;
      }

      _this.$showLoading();
      _this.apiNtcPutDeliveryDay(data).then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.$dialogs.alert("NTC 결제일이 변경되었습니다.", {okLabel:"확인"})
          .then(res => {});

          _this.loadData();

        }else{
          //console.error(res);
          _this.$dialogs.alert(res.data.message).then(res => {});
        }

      }).catch(()=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    //Open Dialog결제정보 변경
    openPaymentInfoDialog(){
      let _this = this;

      //pass data to dialog
      _this.paymentInfoDialog = {
        //..._this.paymentInfoDialog,
        mode : 2, //신용카드, 계좌이체 모두
        paymentType : 2,
        card :{
          cardnumber : Crypto.replaceStringForNtcCardNumberAndExp(_this.viewData.ccard_no, _this.viewData, _this.getMemberId()),
          birth : '',

          useTerm : _this.$aroApiBasePath + _this.AroConst.VALUE_NTC_CARD_USE_TERM
        },
        account:{

        }
      };
      _this.$refs.paymentInfoDialog.initData(_this.paymentInfoDialog);
      _this.paymentInfoDialogShow = true;
    },

    //결제정보 변경
    changePaymentInfo(isOk, data){
      let _this = this;

      _this.paymentInfoDialogShow = false;

      if(!isOk){
        //Do nothing
        return;
      }

      let paymentInfo = {
        birth_dt : data.card.birth,
        ccard_no : data.card.cardnumber,
        ccard_exp : data.card.expYY + data.card.expMM,
        passwd : data.card.pwd,
      };

      //show loading
      _this.$showLoading();
      _this.apiNtcPutPay(paymentInfo).then((res)=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.$dialogs.alert("결제 정보를 변경 하였습니다.")
          .then(res => {});

          _this.loadData();
          return;
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
         _this.$hideLoading();
      });
    },

  }
}
</script>
<style>
a.rew19-btn-normal, a.rew19_btn_T1, a.rew19_btn_border{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/my/ntc/currentDetail.vue